module.exports = __webpack_public_path__ + "img/divider.0ba53df7.svg";